import { render, staticRenderFns } from "./workflow-states-table-item.vue?vue&type=template&id=2faf90c6"
import script from "./workflow-states-table-item.vue?vue&type=script&lang=js"
export * from "./workflow-states-table-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports